<style lang="scss">
.infoBoxLabel {
  width: 100%;
}
.card {
  .infoBoxLabel {
    .avatar {
      width: 100%;
      height: 100%;
      border-radius: 0;
      margin-bottom: 0px;
    }
    .text-lg,
    .profile-country,
    .profile-name {
      font-size: 1.1rem;
    }
  }
}
textarea.defaultDialogNote {
  min-height: 10rem;
}
.settings.nav-pills .nav-item .nav-link.active {
  background-color: #007bff;
  border-radius: 0.25rem !important;
}
.settings.nav-pills .nav-item .nav-link {
  border: 0px solid #007bff;
}
.settings.nav.nav-pills {
  margin-bottom: 10px;
}

.watermark-opacity-slider {
  width: 100%;
  height: 16px;
  border-radius: 5px;
}

.watermark-opacity-slider::-webkit-slider-thumb {
  width: 15px;
  height: 15px;
  box-shadow: 0.5px 0.5px 6px 1px rgba(0, 0, 0, 0.32);
}

.watermark-opacity-slider::-moz-range-thumb {
  width: 15px;
  height: 15px;
  box-shadow: 0.5px 0.5px 6px 1px rgba(0, 0, 0, 0.32);
}
</style>

<template>
  <section>
    <div class="card">
      <div class="card-header">
        <h4>Einstellungen</h4>
      </div>
      <div class="card-body">
        <ul class="settings nav nav-pills" id="myTab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" href="#kauf" role="tab"
              >Kauf</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#registrierung"
              role="tab"
              >Registrierung</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#nachrichten" role="tab"
              >Nachrichten</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#fake" role="tab"
              >Fake</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#texte" role="tab"
              >Texte</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#moderation" role="tab"
              >Moderation</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#fake-online" role="tab"
              >Fake Online</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#seo" role="tab">Seo</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#profil-vorschläge"
              role="tab"
              >Profil-Vorschläge</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#erotic-darstellung"
              role="tab"
              >Erotik-Darstellung</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#new-member-darstellung"
              role="tab"
              >Neue Nutzer-Darstellung</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#wasserzeichen"
              role="tab"
              >Wasserzeichen</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#mail-anhaenge"
              role="tab"
              >E-Mail Anhänge</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#profile-visits"
              role="tab"
              >Profilbesuche</a
            >
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="kauf" role="tabpanel">
            <blockquote class="blockquote">
              Bei einem Einkauf zahlt der Kunde eine pauschale von
              {{ data.buyFlatFee }} Euro.
            </blockquote>
            <div class="form-group row">
              <col-label>Kaufpauschale</col-label>
              <div class="col-8">
                <input
                  type="number"
                  class="form-control"
                  v-model="data.buyFlatFee"
                />
              </div>
            </div>
            <hr />
            <div class="form-group row">
              <col-label>Min Einheiten</col-label>
              <div class="col-8">
                <input
                  type="number"
                  class="form-control"
                  v-model="data.buyMinAmount"
                />
              </div>
            </div>
            <div class="form-group row">
              <col-label>Max Einheiten</col-label>
              <div class="col-8">
                <input
                  type="number"
                  class="form-control"
                  v-model="data.buyMaxAmount"
                />
              </div>
            </div>
            <div class="form-group row">
              <col-label>Vorgeschlagene Einheiten</col-label>
              <div class="col-8">
                <input
                  type="number"
                  class="form-control"
                  v-model="data.buySuggestedAmount"
                />
              </div>
            </div>
            <div class="form-group row">
              <col-label>Euro pro Einheit</col-label>
              <div class="col-8">
                <input
                  type="number"
                  class="form-control"
                  v-model="data.buyCurrencyPerUnit"
                />
              </div>
            </div>
          </div>
          <div class="tab-pane fade show" id="registrierung" role="tabpanel">
            <blockquote class="blockquote">
              Ein Kunde erhält nach erfolgreicher Registrierung
              {{ data.freeStartCoins }} Einheiten. Er erhält folgende Nachricht
              nach der Registrierung:
              <div class="font-italic" v-html="data.newUserWelcomeMessage" />
            </blockquote>
            <div class="form-group row">
              <col-label>Starteinheiten</col-label>
              <div class="col-8">
                <input
                  type="number"
                  class="form-control"
                  v-model="data.freeStartCoins"
                />
              </div>
            </div>
            <div class="form-group row">
              <col-label>Willkommensnachricht</col-label>
              <div class="col-8">
                <vue-editor
                  class="form-control"
                  v-model="data.newUserWelcomeMessage"
                  :editorToolbar="customToolbar"
                />
              </div>
            </div>
          </div>
          <div class="tab-pane fade show" id="nachrichten" role="tabpanel">
            <div class="card-body">
              <div class="form-group row">
                <col-label>Preis pro Textnachricht</col-label>
                <div class="col-8">
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.pricePerMessage"
                  />
                </div>
              </div>

              <div class="form-group row">
                <col-label>Preis pro Erstkontakt</col-label>
                <div class="col-8">
                  <input
                    type="number"
                    min="0"
                    :max="data.pricePerMessage"
                    class="form-control"
                    v-model="data.firstMessagePrice"
                  />
                </div>
              </div>

              <div class="form-group row">
                <col-label>Moderator Anteil</col-label>
                <div class="col-8">
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.moderatorCutPerMessage"
                  />
                </div>
              </div>
              <hr />
              <div class="form-group row">
                <col-label>Preis pro Bild</col-label>
                <div class="col-8">
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.pricePerMedia"
                  />
                </div>
              </div>
              <div class="form-group row">
                <col-label>Moderator Anteil pro Media</col-label>
                <div class="col-8">
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.moderatorCutPerMedia"
                  />
                </div>
              </div>
              <div class="form-group row">
                <col-label>Maximaler Upload in KiloByte</col-label>
                <div class="col-8">
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.maxImageSizeInKB"
                  />
                </div>
              </div>
              <div class="form-group row">
                <col-label>Maximale Auflösung in MegaPixel</col-label>
                <div class="col-8">
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.maxImageResolutionInMP"
                  />
                </div>
              </div>
              <hr />
              <div class="form-group row">
                <col-label>Preis pro Freundschaftsanfrage</col-label>
                <div class="col-8">
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.pricePerFriendRequest"
                  />
                </div>
              </div>
              <div class="form-group row">
                <col-label>Moderator Anteil pro Freundschaftsanfrage</col-label>
                <div class="col-8">
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.moderatorCutPerFriendRequest"
                  />
                </div>
              </div>
              <div class="form-group row">
                <col-label>Preis pro Zwinkern</col-label>
                <div class="col-8">
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.pricePerBlink"
                  />
                </div>
              </div>
              <div class="form-group row">
                <col-label>Moderator Anteil pro Zwinkern</col-label>
                <div class="col-8">
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.moderatorCutPerBlink"
                  />
                </div>
              </div>
              <div class="form-group row">
                <col-label>Preis pro GIF</col-label>
                <div class="col-8">
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.pricePerGIF"
                  />
                </div>
              </div>
              <div class="form-group row">
                <col-label>Moderator Anteil pro GIF</col-label>
                <div class="col-8">
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.moderatorCutPerGIF"
                  />
                </div>
              </div>
              <hr />
              <div class="form-group row">
                <col-label>Name für Zwinkern</col-label>
                <div class="col-8">
                  <input
                    type="text"
                    class="form-control"
                    v-model="data.blinkName"
                  />
                </div>
              </div>
              <div class="form-group row">
                <col-label>Anzeigetext für Zwinkern</col-label>
                <div class="col-8">
                  <input
                    type="text"
                    class="form-control"
                    v-model="data.blinkText"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade show" id="fake" role="tabpanel">
            <blockquote class="blockquote">
              Fakes mit dynamischen Wohnsitz werden
              {{ data.dynamicDistanceMinInKm }} bis
              {{ data.dynamicDistanceMaxInKm }} Kilometer vom Kunden entfernt
              generiert.
            </blockquote>
            <div v-if="data.allow_mark">
              <div class="row">
                <label class="col-sm-3">
                  Art der Kennzeichnung:
                </label>
              </div>
              <div class="form-group row">
                <div class="col-2 text-center">
                  <label class="infoBoxLabel" for="none">
                    <user-short-info-box
                      :settings="true"
                      :key="data.mark.color"
                      :mark="displayFakeModeNone"
                      v-if="!loadingProfile"
                      :newMemberColor="data.displayNewMembersColor"
                      id="Profile"
                      :profile="profile"
                      class="pl-3 pb-3"
                    ></user-short-info-box>
                  </label>
                  <div class="custom-control custom-radio">
                    <input
                      name="mark"
                      class="custom-control-input"
                      type="radio"
                      id="none"
                      value="none"
                      v-model="data.mark.mode"
                    />
                    <label class="custom-control-label" for="none">
                      Deaktiviert
                    </label>
                  </div>
                </div>
                <div class="col-2 text-center">
                  <label class="infoBoxLabel" for="cross">
                    <user-short-info-box
                      :settings="true"
                      :key="data.mark.color + data.mark.location"
                      :mark="displayFakeModeCross"
                      v-if="!loadingProfile"
                      :newMemberColor="data.displayNewMembersColor"
                      id="Profile"
                      :profile="profile"
                      class="pl-3 pb-3"
                    ></user-short-info-box>
                  </label>
                  <div class="custom-control custom-radio">
                    <input
                      name="mark"
                      class="custom-control-input"
                      type="radio"
                      id="cross"
                      value="cross"
                      v-model="data.mark.mode"
                    />
                    <label class="custom-control-label" for="cross">
                      Kreuz
                    </label>
                  </div>
                </div>
                <div class="col-2 text-center">
                  <label class="infoBoxLabel" for="name">
                    <user-short-info-box
                      :settings="true"
                      :key="data.mark.color"
                      :mark="displayFakeModeName"
                      v-if="!loadingProfile"
                      :newMemberColor="data.displayNewMembersColor"
                      id="Profile"
                      :profile="profile"
                      class="pl-3 pb-3"
                    ></user-short-info-box>
                  </label>
                  <div class="custom-control custom-radio">
                    <input
                      name="mark"
                      class="custom-control-input"
                      type="radio"
                      id="name"
                      value="name"
                      v-model="data.mark.mode"
                    />
                    <label class="custom-control-label" for="name">
                      Name
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <col-label>Farbe</col-label>
                <div class="col-2">
                  <el-color-picker v-model="data.mark.color"></el-color-picker>
                </div>
              </div>
              <div class="form-group row">
                <col-label>Position</col-label>
                <div class="col-2">
                  <select class="form-control" v-model="data.mark.location">
                    <option value="topRight">Oben Rechts</option>
                    <option value="topLeft">Oben Links</option>
                    <option value="bottomRight">Unten Rechts</option>
                    <option value="bottomLeft">Unten Links</option>
                    <option value="center">Mitte</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <col-label
                  >Fake Prefix (wird vor dem Namen angezeigt)</col-label
                >
                <div class="col-8">
                  <input
                    type="text"
                    class="form-control"
                    v-model="data.mark.prefix"
                  />
                </div>
              </div>
              <div class="row">
                <col-label
                  >Fake Suffix (wird hinter dem Namen angezeigt)</col-label
                >
                <div class="col-8">
                  <input
                    type="text"
                    class="form-control"
                    v-model="data.mark.suffix"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <col-label>Min Distanz der dynamischen Fakes (km)</col-label>
              <div class="col-8">
                <input
                  type="number"
                  class="form-control"
                  v-model="data.dynamicDistanceMinInKm"
                />
              </div>
            </div>
            <div class="form-group row">
              <col-label>Max Distanz der dynamischen Fakes (km)</col-label>
              <div class="col-8">
                <input
                  type="number"
                  class="form-control"
                  v-model="data.dynamicDistanceMaxInKm"
                />
              </div>
            </div>
          </div>
          <div class="tab-pane fade show" id="texte" role="tabpanel">
            <div class="form-group row">
              <col-label
                >Nachricht für Kunde desen Bild abgelehnt wurde</col-label
              >
              <div class="col-8">
                <vue-editor
                  class="form-control"
                  v-model="data.messsageForDeniedMedia"
                  :editorToolbar="customToolbar"
                />
              </div>
            </div>
            <div class="form-group row">
              <col-label
                >Nachricht für Kunde desen Beschreibung abgelehnt
                wurde</col-label
              >
              <div class="col-8">
                <vue-editor
                  class="form-control"
                  v-model="data.messsageForDeniedDescription"
                  :editorToolbar="customToolbar"
                />
              </div>
            </div>
            <div class="form-group row">
              <col-label>Support E-Mail Footer</col-label>
              <div class="col-8">
                <vue-editor
                  class="form-control"
                  v-model="data.emailFooter"
                  :editorToolbar="customToolbar"
                />
              </div>
            </div>
          </div>
          <div class="tab-pane fade show" id="moderation" role="tabpanel">
            <div class="form-group row">
              <col-label
                >Minimale Anzahl an Zeichen für einen Moderator</col-label
              >
              <div class="col-8">
                <input
                  type="number"
                  class="form-control"
                  v-model="data.minModeratorMessageChars"
                />
              </div>
            </div>
            <div class="form-group row">
              <col-label
                >Minimale Anzahl an Zeichen für eine Asa Nachricht</col-label
              >
              <div class="col-8">
                <input
                  type="number"
                  class="form-control"
                  v-model="data.minModeratorAsaChars"
                />
              </div>
            </div>
            <div class="form-group row">
              <col-label>Sekunden bis Moderator im Chat inaktiv ist</col-label>
              <div class="col-8">
                <input
                  type="number"
                  class="form-control"
                  v-model="data.minModeratorSecondsToInactiv"
                />
              </div>
            </div>
            <div class="form-group row">
              <col-label>Standardwert Dialoginformationen</col-label>
              <div class="col-8">
                <textarea
                  class="form-control defaultDialogNote"
                  v-model="data.defaultDialogNote"
                  rows="6"
                />
              </div>
            </div>
            <div class="form-group row">
              <col-label
                >Moderator muss zusätzliche Text-Nachricht für Bild, Gif,
                Geschenk schreiben für
              </col-label>
              <div class="col-8">
                <div class="custom-control custom-radio">
                  <input
                    class="form-check-input custom-control-input"
                    type="checkbox"
                    v-model="data.multipleMessagesIfgeneralMessage"
                    id="multipleMessagesIfgeneralMessage"
                  />
                  <label
                    class="form-check-label custom-control-label"
                    for="multipleMessagesIfgeneralMessage"
                    >Nachrichten</label
                  >
                </div>
                <div class="custom-control custom-radio">
                  <input
                    class="form-check-input custom-control-input"
                    type="checkbox"
                    v-model="data.multipleMessagesIfAsa"
                    id="multipleMessagesIfAsa"
                  />
                  <label
                    class="form-check-label custom-control-label"
                    for="multipleMessagesIfAsa"
                    >Asas</label
                  >
                </div>
              </div>
            </div>
            <div class="form-group row">
              <col-label>Nachricht auf der "Chat starten"-Seite</col-label>
              <div class="col-8">
                <vue-editor
                  class="form-control"
                  v-model="data.modpanelStartChatText"
                  :editorToolbar="customToolbar"
                />
              </div>
            </div>
          </div>
          <div class="tab-pane fade show" id="fake-online" role="tabpanel">
            <blockquote class="blockquote">
              Fakes werden dynamisch online angezeigt. <br />
              Zwischen 20 und 21 Uhr sind die meisten Fakes online ({{
                maxFakePercentage
              }}%) und gegen 7 Uhr sind die wenigsten Fakes online ({{
                minFakePercentage
              }}%).
            </blockquote>
            <div class="form-group row">
              <col-label>Online Prozent</col-label>
              <div class="col-8">
                <div class="input-group">
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Basis Prozent"
                    v-model="data.fakeOnlineBasePercentage"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <col-label>Online Varianz</col-label>
              <div class="col-8">
                <div class="input-group">
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Basis Prozent"
                    v-model="data.fakeOnlineVarianzPercentage"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade show" id="seo" role="tabpanel">
            <div class="form-group row">
              <col-label>Titel</col-label>
              <div class="col-8">
                <input
                  type="text"
                  class="form-control"
                  v-model="data.seoMetaTitle"
                />
              </div>
            </div>
            <div class="form-group row">
              <col-label>Beschreibung</col-label>
              <div class="col-8">
                <input
                  type="text"
                  class="form-control"
                  v-model="data.seoMetaDescription"
                />
              </div>
            </div>
            <div class="form-group row">
              <col-label>Keywords</col-label>
              <div class="col-8">
                <input
                  type="text"
                  class="form-control"
                  v-model="data.seoMetaKeywords"
                />
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade show"
            id="profil-vorschläge"
            role="tabpanel"
          >
            <blockquote class="blockquote">
              Profilvorschläge mit ausschließlich Fake-Profilen werden in der
              Sidebar angezeigt. <br />
              Die angezeigten Profile werden zufällig ausgewählt und müssen ein
              Bild besitzen.
            </blockquote>
            <div class="form-group row">
              <col-label>Anzahl der Vorschläge</col-label>
              <div class="col-8">
                <input
                  type="text"
                  class="form-control"
                  v-model="data.numberOfProposals"
                />
              </div>
            </div>
            <div class="form-group row">
              <col-label>Maximale Entfernung zum Profil in km</col-label>
              <div class="col-8">
                <input
                  type="text"
                  class="form-control"
                  v-model="data.maxDistanceOfProposals"
                />
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade show"
            id="erotic-darstellung"
            role="tabpanel"
          >
            <div class="row">
              <div class="col-2 text-center">
                <label class="infoBoxLabel" for="none">
                  <user-short-info-box
                    :settings="true"
                    :mark="displayFakeModeNone"
                    v-if="!loadingProfile"
                    :newMemberColor="data.displayNewMembersColor"
                    displayErotic="none"
                    id="Profile"
                    :profile="profile"
                    class="pl-3 pb-3"
                  ></user-short-info-box>
                </label>
                <div class="custom-control custom-radio">
                  <input
                    name="displayErotic"
                    class="custom-control-input"
                    type="radio"
                    id="none"
                    value="none"
                    v-model="data.displayErotic"
                  />
                  <label class="custom-control-label" for="none">
                    Nichts
                  </label>
                </div>
              </div>
              <div class="col-2 text-center">
                <label class="infoBoxLabel" for="triangle">
                  <user-short-info-box
                    :settings="true"
                    :mark="displayFakeModeNone"
                    v-if="!loadingProfile"
                    :newMemberColor="data.displayNewMembersColor"
                    displayErotic="triangle"
                    id="Profile"
                    :profile="profile"
                    class="pl-3 pb-3"
                  ></user-short-info-box>
                </label>
                <div class="custom-control custom-radio">
                  <input
                    name="displayErotic"
                    class="custom-control-input"
                    type="radio"
                    id="triangle"
                    value="triangle"
                    v-model="data.displayErotic"
                  />
                  <label class="custom-control-label" for="triangle">
                    Dreieck
                  </label>
                </div>
              </div>
              <div class="col-2 text-center">
                <label class="infoBoxLabel" for="shadow">
                  <user-short-info-box
                    :settings="true"
                    :mark="displayFakeModeNone"
                    v-if="!loadingProfile"
                    :newMemberColor="data.displayNewMembersColor"
                    displayErotic="shadow"
                    id="Profile"
                    :profile="profile"
                    class="pl-3 pb-3"
                  ></user-short-info-box>
                </label>
                <div class="custom-control custom-radio">
                  <input
                    name="displayErotic"
                    class="custom-control-input"
                    type="radio"
                    id="shadow"
                    value="shadow"
                    v-model="data.displayErotic"
                  />
                  <label class="custom-control-label" for="shadow">
                    Schimmer
                  </label>
                </div>
              </div>
              <div class="col-2 text-center">
                <label class="infoBoxLabel" for="border">
                  <user-short-info-box
                    :settings="true"
                    :mark="displayFakeModeNone"
                    v-if="!loadingProfile"
                    :newMemberColor="data.displayNewMembersColor"
                    displayErotic="border"
                    id="Profile"
                    :profile="profile"
                    class="pl-3 pb-3"
                  ></user-short-info-box>
                </label>
                <div class="custom-control custom-radio">
                  <input
                    name="displayErotic"
                    class="custom-control-input"
                    type="radio"
                    id="border"
                    value="border"
                    v-model="data.displayErotic"
                  />
                  <label class="custom-control-label" for="border">
                    Umrandung
                  </label>
                </div>
              </div>
              <div class="col-2 text-center">
                <label class="infoBoxLabel" for="border-bottom">
                  <user-short-info-box
                    :settings="true"
                    :mark="displayFakeModeNone"
                    v-if="!loadingProfile"
                    :newMemberColor="data.displayNewMembersColor"
                    displayErotic="border-bottom"
                    id="Profile"
                    :profile="profile"
                    class="pl-3 pb-3"
                  ></user-short-info-box>
                </label>
                <div class="custom-control custom-radio">
                  <input
                    name="displayErotic"
                    class="custom-control-input"
                    type="radio"
                    id="border-bottom"
                    value="border-bottom"
                    v-model="data.displayErotic"
                  />
                  <label class="custom-control-label" for="border-bottom">
                    Balken
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade show"
            id="new-member-darstellung"
            role="tabpanel"
          >
            <div class="row">
              <div class="col-2 text-center">
                <label class="infoBoxLabel" for="NewMemberNone">
                  <user-short-info-box
                    :settings="true"
                    :mark="displayFakeModeNone"
                    v-if="!loadingProfile"
                    :key="data.displayNewMembersColor"
                    :newMemberColor="data.displayNewMembersColor"
                    id="Profile"
                    :profile="profile"
                    class="pl-3 pb-3"
                  ></user-short-info-box>
                </label>
                <div class="custom-control custom-radio">
                  <input
                    name="displayNewMembers"
                    class="custom-control-input"
                    type="radio"
                    id="NewMemberNone"
                    value="none"
                    v-model="data.displayNewMembers"
                  />
                  <label class="custom-control-label" for="NewMemberNone">
                    Nichts
                  </label>
                </div>
              </div>
              <div class="col-2 text-center">
                <label class="infoBoxLabel" for="NewMemberTriangle">
                  <user-short-info-box
                    :settings="true"
                    :mark="displayFakeModeNone"
                    v-if="!loadingProfile"
                    :key="data.displayNewMembersColor"
                    :newMemberColor="data.displayNewMembersColor"
                    displayNewMembers="triangle"
                    id="Profile"
                    :profile="profile"
                    class="pl-3 pb-3"
                  ></user-short-info-box>
                </label>
                <div class="custom-control custom-radio">
                  <input
                    name="displayNewMembers"
                    class="custom-control-input"
                    type="radio"
                    id="NewMemberTriangle"
                    value="triangle"
                    v-model="data.displayNewMembers"
                  />
                  <label class="custom-control-label" for="NewMemberTriangle">
                    Dreieck
                  </label>
                </div>
              </div>
              <div class="col-2 text-center">
                <label class="infoBoxLabel" for="NewMemberShadow">
                  <user-short-info-box
                    :settings="true"
                    :mark="displayFakeModeNone"
                    v-if="!loadingProfile"
                    :key="data.displayNewMembersColor"
                    :newMemberColor="data.displayNewMembersColor"
                    displayNewMembers="shadow"
                    id="Profile"
                    :profile="profile"
                    class="pl-3 pb-3"
                  ></user-short-info-box>
                </label>
                <div class="custom-control custom-radio">
                  <input
                    name="displayNewMembers"
                    class="custom-control-input"
                    type="radio"
                    id="NewMemberShadow"
                    value="shadow"
                    v-model="data.displayNewMembers"
                  />
                  <label class="custom-control-label" for="NewMemberShadow">
                    Schimmer
                  </label>
                </div>
              </div>
              <div class="col-2 text-center">
                <label class="infoBoxLabel" for="NewMemberBorder">
                  <user-short-info-box
                    :settings="true"
                    :mark="displayFakeModeNone"
                    v-if="!loadingProfile"
                    :key="data.displayNewMembersColor"
                    :newMemberColor="data.displayNewMembersColor"
                    displayNewMembers="border"
                    id="Profile"
                    :profile="profile"
                    class="pl-3 pb-3"
                  ></user-short-info-box>
                </label>
                <div class="custom-control custom-radio">
                  <input
                    name="displayNewMembers"
                    class="custom-control-input"
                    type="radio"
                    id="NewMemberBorder"
                    value="border"
                    v-model="data.displayNewMembers"
                  />
                  <label class="custom-control-label" for="NewMemberBorder">
                    Umrandung
                  </label>
                </div>
              </div>
              <div class="col-2 text-center">
                <label class="infoBoxLabel" for="NewMemberBorder-bottom">
                  <user-short-info-box
                    :settings="true"
                    :mark="displayFakeModeNone"
                    v-if="!loadingProfile"
                    :key="data.displayNewMembersColor"
                    :newMemberColor="data.displayNewMembersColor"
                    displayNewMembers="border-bottom"
                    id="Profile"
                    :profile="profile"
                    class="pl-3 pb-3"
                  ></user-short-info-box>
                </label>
                <div class="custom-control custom-radio">
                  <input
                    name="displayNewMembers"
                    class="custom-control-input"
                    type="radio"
                    id="NewMemberBorder-bottom"
                    value="border-bottom"
                    v-model="data.displayNewMembers"
                  />
                  <label
                    class="custom-control-label"
                    for="NewMemberBorder-bottom"
                  >
                    Balken
                  </label>
                </div>
              </div>
            </div>
            <hr />
            <div class="form-group row">
              <col-label>Neu für x Tage</col-label>
              <div class="col-8">
                <input
                  type="text"
                  class="form-control"
                  v-model="data.displayNewMembersDays"
                />
              </div>
            </div>
            <div class="form-group row">
              <col-label>Anzuzeigende Farbe</col-label>
              <div class="col-8">
                <el-color-picker
                  v-model="data.displayNewMembersColor"
                ></el-color-picker>
              </div>
            </div>
          </div>
          <div class="tab-pane fade show" id="wasserzeichen" role="tabpanel">
            <div class="row">
              <div class="col-8">
                <div class="form-group row">
                  <col-label>Wasserzeichen</col-label>
                  <div class="col-8">
                    <div class="custom-control custom-checkbox">
                      <input
                        class="form-check-input custom-control-input"
                        type="checkbox"
                        v-model="data.watermarkEnable"
                        id="watermarkEnable"
                      />
                      <label
                        class="form-check-label custom-control-label"
                        for="watermarkEnable"
                        >aktiv</label
                      >
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <col-label>Position</col-label>
                  <div class="col-8">
                    <select
                      class="form-control"
                      v-model="data.watermarkPosition"
                      @change="updateWatermarkPictureUrl()"
                    >
                      <option value="top-left">Oben Links</option>
                      <option value="top">Oben</option>
                      <option value="top-right">Oben Rechts</option>
                      <option value="left">Links</option>
                      <option value="center">Mitte</option>
                      <option value="right">Rechts</option>
                      <option value="bottom-left">Unten Links</option>
                      <option value="bottom">Unten</option>
                      <option value="bottom-right">Unten Rechts</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <col-label>Deckkraft</col-label>
                  <div class="col-8">
                    <input
                      type="range"
                      min="0"
                      max="100"
                      v-model="data.watermarkOpacity"
                      class="watermark-opacity-slider"
                      @change="updateWatermarkPictureUrl()"
                    />
                    <div>{{ data.watermarkOpacity }}%</div>
                  </div>
                </div>
                <div class="form-group row">
                  <col-label>X-Offset</col-label>
                  <div class="col-8">
                    <input
                      type="number"
                      class="form-control"
                      v-model="data.watermarkPositionXOffset"
                      @change="updateWatermarkPictureUrl()"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <col-label>Y-Offset</col-label>
                  <div class="col-8">
                    <input
                      type="number"
                      class="form-control"
                      v-model="data.watermarkPositionYOffset"
                      @change="updateWatermarkPictureUrl()"
                    />
                  </div>
                </div>
              </div>
              <div class="col-4">
                <img :src="watermarkPictureUrl" />
              </div>
            </div>
          </div>
          <div class="tab-pane fade show" id="mail-anhaenge" role="tabpanel">
            <div class="form-group row">
              <col-label>AGB</col-label>
              <div class="col-8">
                <div class="custom-control custom-checkbox">
                  <input
                    class="form-check-input custom-control-input"
                    type="checkbox"
                    v-model="data.mailAttachmentAgb"
                    id="mailAttachmentAgb"
                  />
                  <label
                    class="form-check-label custom-control-label"
                    for="mailAttachmentAgb"
                    >anhängen</label
                  >
                </div>
                <a href="/mail-anhang/AGB" target="_blank">AGB.pdf anzeigen</a>
              </div>
            </div>
            <div class="form-group row">
              <col-label>Datenschutzerklärung</col-label>
              <div class="col-8">
                <div class="custom-control custom-checkbox">
                  <input
                    class="form-check-input custom-control-input"
                    type="checkbox"
                    v-model="data.mailAttachmentPrivatePolicy"
                    id="mailAttachmentPrivatePolicy"
                  />
                  <label
                    class="form-check-label custom-control-label"
                    for="mailAttachmentPrivatePolicy"
                    >anhängen</label
                  >
                </div>
                <a href="/mail-anhang/Datenschutzerklärung" target="_blank"
                  >Datenschutzerklärung.pdf anzeigen</a
                >
              </div>
            </div>
            <div class="form-group row">
              <col-label>Medienrichtlinien</col-label>
              <div class="col-8">
                <div class="custom-control custom-checkbox">
                  <input
                    class="form-check-input custom-control-input"
                    type="checkbox"
                    v-model="data.mailAttachmentMediaPolicy"
                    id="mailAttachmentMediaPolicy"
                  />
                  <label
                    class="form-check-label custom-control-label"
                    for="mailAttachmentMediaPolicy"
                    >anhängen</label
                  >
                </div>
                <a href="/mail-anhang/Medienrichtlinien" target="_blank"
                  >Medienrichtlinien.pdf anzeigen</a
                >
              </div>
            </div>
          </div>
          <div class="tab-pane fade show" id="profile-visits" role="tabpanel">
            <div class="form-group row">
              <col-label
                >Profilebesuche für die letzten x Tage anzeigen</col-label
              >
              <div class="col-8">
                <div class="custom-control custom-radio">
                  <input
                    class="form-check-input custom-control-input"
                    value="3"
                    type="radio"
                    v-model="data.profileVisitDisplayDays"
                    id="profileVisitDisplayDays3"
                  />
                  <label
                    class="form-check-label custom-control-label"
                    for="profileVisitDisplayDays3"
                    >3 Tage</label
                  >
                </div>
                <div class="custom-control custom-radio">
                  <input
                    class="form-check-input custom-control-input"
                    value="7"
                    type="radio"
                    v-model="data.profileVisitDisplayDays"
                    id="profileVisitDisplayDays7"
                  />
                  <label
                    class="form-check-label custom-control-label"
                    for="profileVisitDisplayDays7"
                    >7 Tage</label
                  >
                </div>
                <div class="custom-control custom-radio">
                  <input
                    class="form-check-input custom-control-input"
                    value="14"
                    type="radio"
                    v-model="data.profileVisitDisplayDays"
                    id="profileVisitDisplayDays14"
                  />
                  <label
                    class="form-check-label custom-control-label"
                    for="profileVisitDisplayDays14"
                    >14 Tage</label
                  >
                </div>
              </div>
            </div>
            <div class="form-group row">
              <col-label>Profilbesuche zensieren</col-label>
              <div class="col-8">
                <div class="custom-control custom-checkbox">
                  <input
                    class="form-check-input custom-control-input"
                    type="checkbox"
                    v-model="data.profileVisitLock"
                    id="profileVisitLock"
                  />
                  <label
                    class="form-check-label custom-control-label"
                    for="profileVisitLock"
                    >aktiv</label
                  >
                </div>
              </div>
            </div>
            <div class="form-group row">
              <col-label>Freischaltungskosten</col-label>
              <div class="col-8">
                <input
                  type="number"
                  class="form-control"
                  v-model="data.profileVisitPrice"
                />
              </div>
            </div>
            <div class="form-group row">
              <col-label>Chance auf Profilbesuch bei Moderation</col-label>
              <div class="col-8">
                <input
                  type="range"
                  min="0"
                  max="100"
                  v-model="data.profileVisitOnModerationChance"
                  class="slider"
                />
                <div>{{ data.profileVisitOnModerationChance }}%</div>
              </div>
            </div>
            <blockquote class="blockquote">
              Pro Tag werden Mitgliederprofile
              {{ data.randomFakeProfileVisitsMin }} bis
              {{ data.randomFakeProfileVisitsMax }} Mal zufällig von Fakes
              besucht.
            </blockquote>
            <div class="form-group row">
              <col-label>Min Profilbesuche pro Tag</col-label>
              <div class="col-8">
                <input
                  type="number"
                  min="0"
                  max="20"
                  class="form-control"
                  v-model="data.randomFakeProfileVisitsMin"
                />
              </div>
            </div>
            <div class="form-group row">
              <col-label>Max Profilbesuche pro Tag</col-label>
              <div class="col-8">
                <input
                  type="number"
                  min="0"
                  max="20"
                  class="form-control"
                  v-model="data.randomFakeProfileVisitsMax"
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <button @click="persist()" class="btn btn-primary">
              Speichern
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { VueEditor } from "vue2-editor";
import UserShortInfoBox from "@/components/Customer/UserShortInfoBox.vue";
import { debounce } from "lodash";
import { ColorPicker } from "element-ui";

export default {
  components: {
    VueEditor,
    UserShortInfoBox,
    [ColorPicker.name]: ColorPicker
  },
  created() {
    this.$store
      .dispatch("setting/all")
      .then(() => {
        const settings = this.$store.getters["setting/all"];
        Object.keys(settings).forEach(key => {
          this.data[key] = settings[key];
        });
        this.data.mark = JSON.parse(this.data.mark);
      })
      .then(() => {
        this.updateWatermarkPictureUrl();
        this.updateWatermarkPictureUrl = debounce(
          this.updateWatermarkPictureUrl,
          500
        );
      });
    this.$store
      .dispatch("customerProfile/read", {
        filter: [
          {
            name: "where",
            attributes: {
              id: Laravel.support.id
            }
          },
          {
            name: "with",
            value: "media"
          }
        ],
        appends: ["ins", "outs"]
      })
      .then(() => {
        this.profile = this.customer;
        this.loadingProfile = false;
      });
  },
  watch: {
    "data.pricePerMessage"() {
      if (
        parseInt(this.data.firstMessagePrice) >
        parseInt(this.data.pricePerMessage)
      ) {
        this.data.firstMessagePrice = this.data.pricePerMessage;
      }
    }
  },
  methods: {
    persist() {
      const data = Object.assign({}, this.data);
      data.mark = JSON.stringify(this.data.mark);
      this.$store
        .dispatch("setting/update", data)
        .then(() => {
          this.$notify({
            title: "Einstellungen gespeichert",
            type: "success"
          });
        })
        .catch(error => {
          this.$notify({
            title: error.response.data,
            type: "error"
          });
        });
    },
    updateWatermarkPictureUrl() {
      this.watermarkPictureUrl = `/api/v1/showWatermark?opacity=${this.data.watermarkOpacity}&position=${this.data.watermarkPosition}&xOffset=${this.data.watermarkPositionXOffset}&yOffset=${this.data.watermarkPositionYOffset}`;
    }
  },
  computed: {
    customer() {
      this.$store.commit("customerProfile/updateModel", {
        modelId: Laravel.support.id,
        attributePath: "has_erotic",
        data: true
      });
      this.$store.commit("customerProfile/updateModel", {
        modelId: Laravel.support.id,
        attributePath: "is_new",
        data: true
      });
      return this.$store.getters["customerProfile/find"](Laravel.support.id);
    },
    maxFakePercentage() {
      return (
        parseInt(this.data.fakeOnlineBasePercentage) +
        parseInt(this.data.fakeOnlineVarianzPercentage)
      );
    },
    minFakePercentage() {
      return (
        parseInt(this.data.fakeOnlineBasePercentage) -
        parseInt(this.data.fakeOnlineVarianzPercentage)
      );
    },
    displayFakeModeNone() {
      return { ...this.data.mark, ...{ mode: "none" } };
    },
    displayFakeModeCross() {
      return { ...this.data.mark, ...{ mode: "cross" } };
    },
    displayFakeModeName() {
      return { ...this.data.mark, ...{ mode: "name" } };
    }
  },
  data() {
    return {
      fontSize: 10,
      loadingProfile: true,
      profile: {},
      watermarkPictureUrl: "",
      customToolbar: [
        { header: [false, 1, 2, 3, 4, 5, 6] },
        "bold",
        "italic",
        "underline",
        "strike",
        "code-block",
        { list: "ordered" },
        { list: "bullet" },
        { color: [] },
        { background: [] },
        "clean"
      ],
      data: {
        dynamicDistanceMinInKm: 10,
        dynamicDistanceMaxInKm: 50,
        buyFlatFee: 0,
        buyMinAmount: 5,
        buyMaxAmount: 500,
        buySuggestedAmount: 175,
        buyCurrencyPerUnit: 2,
        freeStartCoins: 1000,
        newUserWelcomeMessage: "",
        pricePerMessage: 4,
        moderatorCutPerMessage: 0.33,
        pricePerMedia: 10,
        moderatorCutPerMedia: 0.33,
        maxImageSizeInKB: 4000,
        maxImageResolutionInMP: 2,
        pricePerFriendRequest: 0,
        moderatorCutPerFriendRequest: 0,
        pricePerBlink: 0,
        moderatorCutPerBlink: 0,
        pricePerGIF: 0,
        moderatorCutPerGIF: 0,
        messsageForDeniedMedia: "",
        emailFooter: "",
        minModeratorMessageChars: 20,
        minModeratorSecondsToInactiv: 30,
        seoMetaTitle: "",
        seoMetaDescription: "",
        seoMetaKeywords: "",
        blinkName: "",
        blinkText: "",
        defaultDialogNote: "",
        fakeOnlineBasePercentage: "25",
        fakeOnlineVarianzPercentage: "5",
        numberOfProposals: 2,
        maxDistanceOfProposals: 150,
        modpanelStartChatText: "",
        multipleMessagesIfgeneralMessage: false,
        multipleMessagesIfAsa: false,
        watermarkEnable: false,
        watermarkOpacity: 100,
        watermarkPositionXOffset: 0,
        watermarkPositionYOffset: 0,
        mailAttachmentAgb: false,
        mailAttachmentPrivatePolicy: false,
        mailAttachmentMediaPolicy: false,
        profileVisitLock: true,
        profileVisitPrice: 5,
        profileVisitOnModerationChance: 20,
        randomFakeProfileVisitsMin: 1,
        randomFakeProfileVisitsMax: 4,
        displayNewMembersColor: "#000000",
        profileVisitDisplayDays: 14,
        landingpageActive: 1,
        firstMessagePrice: 0,
        allow_mark: false,
        mark: {}
      }
    };
  }
};
</script>
